import { z } from 'zod/v4';

export const THIRD_PARTY_TYPES = ['lawyer', 'bailiff', 'debt_collector'] as const;

export type ThirdPartyCaseTypes = (typeof THIRD_PARTY_TYPES)[number];

export const ThirdPartyCaseTypesSchema = z.enum([...THIRD_PARTY_TYPES]);
